import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showSummary: false,
    summary: null,
};

const segmentSummarySlice = createSlice({
    name: 'SegmentSummary',
    initialState,
    reducers: {
        showSummaryAction: (state, action) => {
            state.showSummary = true;
            if (action.payload) {
                state.summary = action.payload
            }
        },
        hideSummaryAction: (state) => {
            state.showSummary = false;
            state.summary = null
        }
    },
});

export const {
    showSummaryAction,
    hideSummaryAction,
} = segmentSummarySlice.actions;

export default segmentSummarySlice.reducer;
